import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FaqServicesComponent } from '../../components/faq-services/faq-services';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';

@Component({
    imports: [CommonModule, FaqServicesComponent, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-faqs',
    standalone: true,
    templateUrl: './faqs.page.html'
})
export class FaqsPage implements OnInit {

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('FAQs: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Frequently Asked Questions.' }
    )
  }
}
